export default __webpack_public_path__ + "static/media/white-teeth.388a02c3.jpg";